<!-- TODO: Get the static data below from API -->
<p class="mt-5">
  Pour obtenir un compte, nous signaler de possibles améliorations ou obtenir plus d'informations, merci de nous
  adresser un mail à l'adresse :
  <br />
  <a href="mailto:contacts@statdechets-ge.ch">contacts@statdechets-ge.ch</a>
</p>
<button class="btn-link mt-2 px-0" (click)="openPrivacyDialog()">Mentions légales</button>
